import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { NetworkConstants, SpeciesValues } from 'diwimamodelweb/lib';
import { BehaviorSubject } from 'rxjs';
import { GameRecordForm } from '../model/form';

@Component({
  selector: 'app-gamerecord-form-species',
  templateUrl: './gamerecord-form-species.component.html',
  styleUrls: ['./gamerecord-form-species.component.css', '../../app.component.scss']
})
export class GamerecordFormSpeciesComponent implements OnInit {

  @Input() data: GameRecordForm
  @Input() formBuilder: FormBuilder
  @Input() translateService: TranslateService
  @Output() submit = new EventEmitter<void>()

  species: SpeciesValues[]

  speciesForm: FormGroup
  diplayGenderSelect = false
  ageClassesSubject$ = new BehaviorSubject<string[]>(undefined)
  readonly genderUnknownValue = 'Unbestimmt'

  formInvalid = true


  constructor() { }

  ngOnInit(): void {
    this.species = this.data.constextSettings.get(NetworkConstants.SETTING_SPECIES).values as any[]
    this.speciesForm = this.formBuilder.group({
      wildart: [],
      gender: [],
      age: []
    })
    if (this.data.data) {
      this.initilzeWithData()
    }

    this.speciesForm.controls.wildart.valueChanges.subscribe(() => {
      this.speciesForm.controls.age.setValue(undefined)
    })

    this.speciesForm.valueChanges.subscribe((value) => {
      const {wildart, gender, age} = value
      this.setAgeClassesSubject(wildart, gender)
      if (!wildart) this.diplayGenderSelect = false
      else if (wildart && gender && age) {
        this.formInvalid = false
      }
      else this.diplayGenderSelect = true
      if (!wildart || !gender || !age) this.formInvalid = true
    })
  }

  initilzeWithData() {
    const {wildart, gender, age} = this.data.data
    this.speciesForm.patchValue({
      wildart, gender, age
    })
    if (wildart) {
      this.diplayGenderSelect = true
      if (gender) {
        this.setAgeClassesSubject(wildart, gender)
      }
    }
    
  }

  setAgeClassesSubject(wildart, gender) {
    this.ageClassesSubject$.next(undefined)
    if (!wildart || !gender) return
    // const wildart = this.speciesForm.controls.wildart.value
    const ind = this.species.findIndex(el => el.identifier == wildart)
    let ageClasses: any = undefined
    if (gender == "M") {
      ageClasses = this.species[ind].ageClassesMale.de
    }
    else if (gender == "F") {
      ageClasses = this.species[ind].ageClassesFemale.de
    }
    else if (gender == this.genderUnknownValue) {
      // Cast: ageClassesUnknown may not yet be declared on the shipped SpeciesValues type.
      ageClasses = (this.species[ind] as any).ageClassesUnknown?.de
    }
    this.ageClassesSubject$.next(ageClasses)
  }

  hasUnknownGenderOption(): boolean {
    if (this.speciesForm.get('gender')?.value === this.genderUnknownValue) return true
    const wildart = this.speciesForm.get('wildart')?.value
    if (!wildart) return false
    const sp = this.species.find(el => el.identifier == wildart)
    return !!(sp as any)?.ageClassesUnknown?.de?.length
  }

  onSubmit() {
    // const {wildart, gender, age} = this.speciesForm.value
    if (!this.data.data) return 
    this.data.data?.setFromAny(this.speciesForm.value)
    this.submit.emit()
  }

}
